import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preconnect to external domains
if (typeof document !== 'undefined') {
  const preconnect1 = document.createElement('link');
  preconnect1.rel = 'preconnect';
  preconnect1.href = 'https://fonts.gstatic.com';
  preconnect1.crossOrigin = 'anonymous';
  document.head.appendChild(preconnect1);
  const preconnect2 = document.createElement('link');
  preconnect2.rel = 'preconnect';
  preconnect2.href = 'https://connect.facebook.net';
  document.head.appendChild(preconnect2);
  const preconnect3 = document.createElement('link');
  preconnect3.rel = 'preconnect';
  preconnect3.href = 'https://cdn.magicpatterns.com';
  document.head.appendChild(preconnect3);
}
// Load Meta Pixel asynchronously after page load
if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    const script = document.createElement('script');
    script.async = true;
    script.innerHTML = `
      !function(f,b,e,v,n,t,s){
        if(f.fbq)return;
        n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;
        n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];
        t=b.createElement(e);t.async=!0;
        t.src=v;
        s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)
      }(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
      
      fbq('init', '1688179945683486');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
  });
}
render(<App data-id="element-271" />, document.getElementById('root'));